import {
  SredDocumentationStatus,
  sredDocumentationStatusLabel,
  sredProjectCategoryLabel,
  SelectedSredProjectCategory,
} from '@common/neo.tax';

import { ColumnDefinition, FilterField, FilterSortDataType } from '@neo.tax/shared';
import { SredProjectFilter } from '@neo.tax/shared/graphql';

export const filterableSredProjectColumns = [
  { name: 'name', label: 'Name', dataType: FilterSortDataType.TEXT },
  { name: 'productName', label: 'Product', dataType: FilterSortDataType.TEXT },
  {
    name: 'selectedCategory',
    label: 'Selected Category',
    dataType: FilterSortDataType.ENUM,
    enum: Object.entries(sredProjectCategoryLabel).map(([value, label]) => ({
      value: value as SelectedSredProjectCategory,
      label: label as string,
    })),
  },
  {
    name: 'aiGuidance',
    label: 'AI Guidance',
    dataType: FilterSortDataType.ENUM,
    enum: [
      { value: 'SR&ED Credit Eligible', label: 'SR&ED Credit Eligible' },
      { value: 'Needs Review', label: 'Needs Review' },
      { value: 'Not Qualified', label: 'Not Qualified' },
    ],
  },
  {
    name: 'sredDocumentationStatus',
    label: 'SR&ED Details',
    dataType: FilterSortDataType.ENUM,
    enum: Object.entries(sredDocumentationStatusLabel).map(([value, label]) => ({
      value: value as SredDocumentationStatus,
      label: label as string,
    })),
  },
  { name: 'workstreamNamesSearch', label: 'Teams', dataType: FilterSortDataType.TEXT },
  {
    name: 'ticketCount',
    label: 'Ticket Count',
    dataType: FilterSortDataType.NUMBER,
  },
  { name: 'projectOwnerName', label: 'Project Owner', dataType: FilterSortDataType.TEXT },
] as const satisfies readonly ColumnDefinition<FilterField<SredProjectFilter>>[];

export const sortableSredProjectColumns = [
  ...filterableSredProjectColumns,
] as const satisfies readonly ColumnDefinition<FilterField<SredProjectFilter>>[];
